import {TableRow} from "@mui/material";
import {TableHeaderProps} from "./TableTypes";
import {ProjectTableCell} from "./ProjectTableCell";

interface TableRowProps<T extends {id:string}> {
    headers:TableHeaderProps<T>[]
    row:T
    loading?: boolean
}

export function ProjectTableRow<T extends {id:string}>({headers, row, loading}:TableRowProps<T>) {
    return <TableRow>
        {headers.map((header) => (
            <ProjectTableCell header={header} row={row} key={header.key} loading={loading}/>
        ))}
    </TableRow>
}